/**
* DevExpress Dashboard (_tab-container-item-surface.js)
* Version:  20.2.9
* Build date: Aug 16, 2021
* Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ko = require("knockout");
var _tab_container_item_properties_composer_1 = require("../properties-composers/_tab-container-item-properties-composer");
var _tab_page_properties_composer_1 = require("../properties-composers/_tab-page-properties-composer");
var _section_descriptors_1 = require("../_section-descriptors");
var _base_item_surface_1 = require("./_base-item-surface");
var TabContainerItemSurface = (function (_super) {
    __extends(TabContainerItemSurface, _super);
    function TabContainerItemSurface(dashboardItem, _dashboardModel, dataSourceBrowser) {
        var _this = _super.call(this) || this;
        _this.dashboardItem = dashboardItem;
        _this._dashboardModel = _dashboardModel;
        return _this;
    }
    TabContainerItemSurface.prototype.getPropertiesComposer = function () {
        var _this = this;
        var editTabPageHandler = function (tabPage, args) {
            var composer = new _tab_page_properties_composer_1.DashboardTabPagePropertiesComposer(_this._dashboardItemCustomization);
            var tabs = composer.composeTabs(tabPage);
            _this.propertiesController.secondaryModel({
                displayText: ko.pureComputed(function () { return _this._dashboardModel._getDisplayDashboardItem(tabPage).name(); }),
                data: {
                    model: tabPage,
                    propertiesTabs: ko.observableArray(tabs)
                },
                containingCollection: _this.dashboardItem.tabPages
            });
        };
        return new _tab_container_item_properties_composer_1.TabContainerItemPropertiesComposer(editTabPageHandler);
    };
    TabContainerItemSurface.prototype.dispose = function () {
    };
    return TabContainerItemSurface;
}(_base_item_surface_1.BaseItemSurface));
exports.TabContainerItemSurface = TabContainerItemSurface;
_section_descriptors_1.surfaceItemsFactory.register('TabContainer', TabContainerItemSurface);
